'use client';

import { Toaster } from 'sonner';

export function GlobalToaster() {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `section:has([data-sonner-toaster]) {
  z-index: 999999999 !important;
  position: fixed !important;
}`,
        }}
      />
      <Toaster
        position="bottom-center"
        richColors
        toastOptions={{
          style: {
            background: '#ab0013',
            border: '1px solid rgba(255,255,255,0.2)',
            color: '#ffffff',
          },
        }}
      />
    </>
  );
}
